import { render, staticRenderFns } from "./sectionFour.vue?vue&type=template&id=607a024f&scoped=true&"
import script from "./sectionFour.vue?vue&type=script&lang=js&"
export * from "./sectionFour.vue?vue&type=script&lang=js&"
import style0 from "./sectionFour.vue?vue&type=style&index=0&id=607a024f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a024f",
  null
  
)

export default component.exports